import PropTypes from 'prop-types'

import { isBlank } from 'utils'

import CustomerOrder from 'components/CustomerOrder'
import Text from 'components/Text'

import { BlankSlate, Root } from './CustomerOrders.style'

const CustomerOrders = ({ orders }) => {
  return (
    <Root>
      {isBlank(orders) ? (
        <BlankSlate>
          <Text>No orders found</Text>
        </BlankSlate>
      ) : (
        <table>
          <thead>
            <tr>
              <th>
                <Text font="proxima">Date</Text>
              </th>
              <th>
                <Text font="proxima">Order No.</Text>
              </th>
              <th>
                <Text font="proxima">Location</Text>
              </th>
              <th colSpan={2}>
                <Text font="proxima">Sales Associate</Text>
              </th>
            </tr>
          </thead>
          <tbody>
            {orders?.map((order) => (
              <CustomerOrder key={order.id} order={order} />
            ))}
          </tbody>
        </table>
      )}
    </Root>
  )
}

CustomerOrders.propTypes = {
  orders: PropTypes.array,
}

CustomerOrders.defaultProps = {
  orders: [],
}

export default CustomerOrders
